import TiktokLookup from '../components/forms/TiktokLookup'

const Tiktok = () => <TiktokLookup />
Tiktok.displayName = 'TiktokLookupPage'
Tiktok.getLayout = page => page

export default Tiktok
